import { Modalitat, ModalitatEnum } from '../shared/modalitat.d';

export type AssessoriaModalitat = Modalitat;

export const AssessoriaModalitatEnum = {
  ...ModalitatEnum,
};
